import { render, staticRenderFns } from "./DeleteAdvertisementButton.vue?vue&type=template&id=2b8a6d5e&"
import script from "./DeleteAdvertisementButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteAdvertisementButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports